import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";
import { NotificationGroup } from "@/types/notification";

@Component
export class NotificationHttp extends Vue {
	public getGroups(): Promise<AxiosResponse<any>> {
		return axios.get(process.env.VUE_APP_API_ENDPOINT + "/notifications/groups", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public createGroup(notificationGroup: NotificationGroup): Promise<AxiosResponse<any>> {
		return axios.post(
			process.env.VUE_APP_API_ENDPOINT + "/notifications/groups",
			{
				notificationGroup,
			},
			{
				headers: {
					authorization: "Bearer " + localStorage.getItem("access_token"),
				},
			}
		);
	}

	public getGroupById(id: string): Promise<AxiosResponse<any>> {
		return axios.get(process.env.VUE_APP_API_ENDPOINT + "/notifications/groups/" + id, {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public updateGroup(notificationSetup: NotificationGroup): Promise<AxiosResponse<any>> {
		return axios.put(
			process.env.VUE_APP_API_ENDPOINT + "/notifications/groups/" + notificationSetup.id,
			notificationSetup,
			{
				headers: {
					authorization: "Bearer " + localStorage.getItem("access_token"),
				},
			}
		);
	}

	public deleteGroup(notificationGroup: NotificationGroup): Promise<AxiosResponse<any>> {
		return axios.delete(
			process.env.VUE_APP_API_ENDPOINT + "/notifications/groups/" + notificationGroup.id,
			{
				headers: {
					authorization: "Bearer " + localStorage.getItem("access_token"),
				},
			}
		);
	}
}
